<template>
    <form class="form-horizontal" >
        <div class="form-group">
            <label for="apn" class="col-sm-2 control-label">SAÍDA 1</label>
            <div class="col-sm-8">
                <select v-model="output1"  class="form-control" >
                    <option value="NORMAL">NORMAL</option>
                    <option value="INVERTE">INVERTIDA</option>
                </select>
            </div>
        </div>
        <div class="form-group" v-if="enable_output2">
            <label for="apn" class="col-sm-2 control-label">SAÍDA 2</label>
            <div class="col-sm-8">
                <select v-model="output2"  class="form-control" >
                    <option value="NORMAL">NORMAL</option>
                    <option value="INVERTE">INVERTIDA</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> SALVAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import { Bus } from '../../../class/bus';
import { Rastreador } from '../../../class';

export default {
    name: 'OutputOptions',
    props: {
        id_rastreador: {
            "defaultValue": null
        },
        output1: {
            "defaultValue": 'NORMAL'
        },
        output2: {
            "defaultValue": 'NORMAL'
        },
        enable_output2: {
            "defaultValue": false
        }
    },
    methods: {
        send () {
            swal({
                title: 'Posso Confirmar?',
                text: "Deseja realmente salvar esta configuração?",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, pode salvar!'
            }).then(async () => {
                try {
                    if (! this.id_rastreador) {
                        return alert('SEM RASTREDAIR');
                    }
                    //await Concox.sendApn(this.config);
                    await Rastreador.sendOutputs(this.id_rastreador, {
                        output1: this.output1 ? this.output1 : 'NORMAL',
                        output2: this.output2 ? this.output2 : 'NORMAL',
                    })
                    this.$emit('update:output1', this.output1);
                    this.$emit('update:output2', this.output2);
                    Bus.$emit('comandos');
                    toastr.success("Configuração salva!");
                } catch (err) {
                    console.log(err);
                    return toastr.error("Configuração não enviada!");
                }
            });
        }
    }
}
</script>
